import React from 'react';
import Table from '../../../../Components/Table';
import './styles.css';

/*=============================================
=            Table Events Builder             =
=============================================*/

function TablesEvent(props) {
  return (
    <div >
      {
        props.allTables.map((e, key) => (
          <>
            <div className="col-12" key={key}>
              <div className="row">
                <div className="col-12" style={{ marginLeft: "8px" }}>
                  <legend className="tableTitleContenedor">{e.eventType}</legend>
                </div>
                <div className="col-12">
                  {/* <div className="table_container" style={{ marginLeft: "-24px", marginTop: "-2em" }}> */}
                  <div className="table_container">
                    <Table
                      headerClass={props.headerClass}
                      columns={props.columns}
                      data={e.data}
                      colorHeader={props.colorHeader}
                      options={{
                        large: true,
                        isEvent: true,
                        downloads: {
                          pdf: false,
                          xlsx: false
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
              <div style={{ height: 49 }} /></div>
          </>
        ))
      }
    </div >
  );
}

export default TablesEvent;
